<template lang="pug">
  ol.responsive-table.sheet-list
    sheet-tile(
      v-for="(sheet, idx) in sheets"
      :key="`sheet-${idx}`"
      :sheet="sheet"
    )
</template>

<script>
import SheetTile from './sheet-tile/SheetTile.vue';

export default {
  name: 'SheetList',
  components: {
    SheetTile
  },
  props: {		
    sheets: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss">
  .sheet-list {
    
  }
</style>